
import "./App.css"
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Navbar from "../src/Components/navbar/navbar";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Footer from "../src/Components/footer/footer.js";
import Home from "../src/Components/Pages/home/home.js";
import Login from "../src/Components/Pages/login/login.js";
import Register from "../src/Components/Pages/register/register.js";
import Refund from "../src/Components/Pages/refund/page.js"
import PrivacyPolicy from "../src/Components/Pages/privacy/page.js"
import TermsAndConditions from "../src/Components/Pages/terms_and_conditions/page.js"
import AboutUs from "../src/Components/Pages/about/page.js"
import ContactUs from "../src/Components/Pages/contact/page.js"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  return (
    <BrowserRouter>
      <div className="overlay">

        <Navbar />
        <ToastContainer toastStyle={{ marginTop: "80px" }} />
        <div className="App" style={{ minHeight: 88 + "vh" }}>
          <Switch>
            <Route path="/contact_us" render={() => <ContactUs />} />
            <Route path="/about_us" render={() => <AboutUs />} />
            <Route path="/terms_and_conditions" render={() => <TermsAndConditions />} />
            <Route path="/privacy" render={() => <PrivacyPolicy />} />
            <Route path="/refund" render={() => <Refund />} />
            <Route path="/Register" render={() => <Register />} />
            <Route path="/login" render={() => <Login />} />
            <Route path="/" render={() => <Home />} />
          </Switch>
        </div>
        <Footer />
      </div>

    </BrowserRouter>
  );
}

export default App;
